export default {
  HOME: "/",
  VIDEOS: "videos",
  ACTIVITIES: "activities",
  GAMES: "games",
  TAGS: "tags",
  PROFILES: "profiles",
  CHAMP_COLLECTION: "champ-collection",
  ACCOUNT_SETTINGS: "account-settings",
  LOGIN: "login",
  REGISTRATION: "registration",
  FAVORITES: "favorites",
  COMPANY: "company",
  SEARCH: "search",
  CURRICULUM: "curriculum",
  EXTERNAL_LINK_DISCLAIMER: "external-link-disclaimer",
};
